// extracted by mini-css-extract-plugin
module.exports = {"textArea":"text-area-7dd"};